<template v-loading="loading">
  <div class="main">
    <div class="header-main">
      <div class="header-text">
        查找经销商：
      </div>
      <div class="header-button">
        <el-input size="small" v-model="search" placeholder="请输入经销商全称" clearable
                  @keyup.enter.native="searchDealer"></el-input>
        <el-button size="small" @click="searchDealer">查找</el-button>
      </div>
    </div>


    <div id="show_none">
      <p style="font-size: 40px;text-align: center;margin: auto;color: #cccccc;margin-top: 90px;letter-spacing: 12px">
        未查询到数据</p>
    </div>
    <div class="show" id="show">
      <h2>{{companyName}}</h2>
      <p>负责区域：{{responsibleArea}}</p>
      <p>联系人：{{contacts1}}</p>
      <p>公司电话：{{companyPhone}}</p>
      <p>公司地址：{{companyAddress}}</p>
      <p>经营范围：{{businessScope}}</p>
    </div>

    <div class="explain">
      <p>查询说明：</p>
      <p>一、必须输入公司全称才能查询经销商相关资质</p>
      <p>二、如遇“括号”请切换到中文输入法，如XXX（北京）有限公司</p>
      <p>三、也可通过以下方式查询：</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;1、电话查询 400-638-6068</p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;2、邮件发至 cs@weiconyt.com</p>
    </div>
  </div>

</template>

<script>
  export default {
    name: "findDealer",
    data() {
      return {
        activeIndex: '1',
        search: '',
        companyName: '',
        responsibleArea: '',     //负责区域
        contacts1: '',
        companyPhone: '',
        companyAddress: '',
        businessScope: '',          //经营范围
        loading: false
      };
    },
    methods: {
      handleSelect(key, keyPath) {
        // console.log(key, keyPath);
      },

      searchDealer() {
        this.loading = true;
        this.$http.get("https://yuanteng.tech:8081/dealer/findByCompanyName?companyName=" + this.search).then(res => {
          var showNone = document.getElementById("show_none");
          var showDiv = document.getElementById("show");
          if (res.data.length == 0) {
            showDiv.style.display = "none";
            showNone.style.display = "block";
          } else {
            showNone.style.display = "none";
            showDiv.style.display = "block";
            this.companyName = res.data.companyName;
            this.responsibleArea = res.data.responsibleArea;
            this.contacts1 = res.data.contacts1;
            this.companyPhone = res.data.companyPhone;
            this.companyAddress = res.data.companyAddress;
            this.businessScope = res.data.businessScope;
          }
        }).finally(() => {
          this.loading = false;
        });
      }

    },
    created() {

    }
  }
</script>

<style scoped>
  .el-input {
    /*width: 15vw;*/
  }

  .main {
    margin-left: 15px;
  }

  .header-main {
    display: flex;
    justify-content: left;
    align-items: center;
    flex-wrap: wrap;
  }

  .header-text {
    font-size: 14px;
    margin: 5px 0;
  }

  .header-button {
    display: flex;
  }

  .header-button button {
    margin-left: 8px;
  }

  .explain {
    margin-top: 70px;
    margin-left: 30px;
    text-align: left;
    font-size: 14px;
  }

  #show_none {
    display: none;
  }

  .show {
    margin: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    width: 85%;
    min-height: 230px;
    text-align: left;
    padding: 10px 20px;
    border: 1px solid #e6e6e6;
    font-size: 14px;
    display: none;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
  }


  @media screen and (max-width: 768px) {
    .explain {
      margin-top: 40px;
      margin-left: 10px;
    }

    .main {
      margin-left: 0;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/findDealer.vue